import { Navigate, Outlet, Route } from 'react-router';
import Loadable from 'components/Loadable';
import { lazy } from 'react';

const AuthLoginPage = Loadable(lazy(() => import('pages/auth/login/LoginPage')));
const AuthLoginCodeVerification = Loadable(lazy(() => import('pages/auth/login/CodeVerification')));
const AuthForgotPasswordEnterEmail = Loadable(lazy(() => import('pages/auth/forgotPassword/enterEmail')));
const AuthForgotPasswordCodeEmailVerification = Loadable(lazy(() => import('pages/auth/forgotPassword/codeEmailVerification')));
const AuthForgotPasswordConfirmation = Loadable(lazy(() => import('pages/auth/forgotPassword/confirmation')));

const LoginRoutes = <Route path='/*' element={<Outlet />}>
    <Route path='login/*'>
        <Route path='' element={<AuthLoginPage />} />
        <Route path='codeVerification' element={<AuthLoginCodeVerification />} />
        <Route path='*' element={<Navigate replace to={'/login'} />} />
    </Route>
    <Route path='forgotPassword/*'> 
        <Route path='enterEmail' element={<AuthForgotPasswordEnterEmail />} />
        <Route path='emailVerification' element={<AuthForgotPasswordCodeEmailVerification />} />
        <Route path='confirmation' element={<AuthForgotPasswordConfirmation />} /> 
        <Route path='*' element={<Navigate replace to={'/login'} />} />
    </Route>
    <Route path='*' element={<Navigate replace to={'/login'} />} />
</Route>

export default LoginRoutes;